import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Login } from './login';
import { Observable, Subject, catchError, map, throwError } from 'rxjs';
import { VitaError } from './vita-error';
import { firstValueFrom } from 'rxjs';

interface User {
  permissions: Record<string, any>; 
  id?: string;
  name?: string;
}

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  private authenticatedSource = new Subject<boolean>()
 
  private user?: User;

  constructor(private http: HttpClient) { }

  onRegister(registerEmail: string): Observable<boolean> {
    const formValues = `email=${registerEmail}`;

    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post('/api/register', formValues, { headers: baseHeaders })
      .pipe(map(() => {
        return true
      }));
  }

  checkRegistrationToken(token: string): Observable<Object> {
    const formValues = `token=${token}`;

    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post('/api/tokenCheck', formValues, { headers: baseHeaders })
      .pipe(map(() => {
        return true
      }));
  }

  resetPassword(token: string, email: string, password: string, vpassword: string): Observable<Login> {
    const formValues = `token=${token}&email=${email}&password=${password}&vpassword=${vpassword}`;

    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<Login>('/api/resetPassword', formValues, { headers: baseHeaders })
      .pipe(map((response: Login) => {
        const token: string = response['access_token']
        if (token) {
          this.setToken(token)
          this.authenticatedSource.next(true)
        }
        return response
      }), catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        const vitaError = error.error as VitaError
        if (vitaError != null) {
          errorMessage = vitaError.message
        } else if (error.error instanceof ErrorEvent) {
          // Client-side error
          errorMessage = `An error occurred: ${error.error.message}`;
        } else {
          // Server-side error
          errorMessage = `Server returned code: ${error.status}, error message: ${error.message}`;
        }
        return throwError(() => new Error(errorMessage)); // Re-throw for further handling

      }));
  }

  onLogin(loginEmail: string, loginPassword: string): Observable<Login> {
    const formValues = `email=${loginEmail}&password=${loginPassword}`;

    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<Login>('/api/login', formValues, { headers: baseHeaders })
      .pipe(map((response: Login) => {
        const token: string = response['access_token']
        const user = response['user']
        if (token) {
          this.setToken(token)
          this.setUser(user)
          this.authenticatedSource.next(true)
        }
        return response
      }), catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        const vitaError = error.error as VitaError
        if (vitaError != null) {
          errorMessage = vitaError.message
        } else if (error.error instanceof ErrorEvent) {
          // Client-side error
          errorMessage = `An error occurred: ${error.error.message}`;
        } else {
          // Server-side error
          errorMessage = `Server returned code: ${error.status}, error message: ${error.message}`;
        }
        return throwError(() => new Error(errorMessage)); // Re-throw for further handling

      }));
  }

  onLogout() {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    this.authenticatedSource.next(false)
  }

  setToken(token: string): void {
    localStorage.setItem('token_last_checked_at', String(Date.now()));
    return localStorage.setItem('token', token)
  }
  setUser(user: object): void {
    localStorage.setItem('user', JSON.stringify(user));
  }

  getToken(): string | null{
    const token = localStorage.getItem('token');
    const lastCheckedAt = localStorage.getItem('token_last_checked_at') ?? 0;
    const user = localStorage.getItem('user') ?? false
    var isCurrent = false
    // console.log('getToken called lastCheckedAt', user, lastCheckedAt, Number(lastCheckedAt) <= Date.now() + 1000*10)
    // make sure token is still valid every 5 mins
    if (user && Number(lastCheckedAt) <= Date.now() + 1000*60*5) {
      // console.log("getToken validating token")
      // hate that i had to it this way, but would've taken a lot more work to it async
      const xhr = new XMLHttpRequest();
      xhr.open('get', "/api/user/?validate", false); // the false here makes it a synchronous request
      xhr.setRequestHeader('Authorization', `Bearer ${token}`);
      try {
        xhr.send(null); 
        if (xhr.status === 200) {
          var validateResult = JSON.parse(xhr.responseText);
          localStorage.setItem('token_last_checked_at', String(Date.now()));
        } 
        else {
          console.log("Expired token, resetting user")
          localStorage.removeItem('token')
          localStorage.removeItem('token_last_checked_at')
          localStorage.removeItem('user')
          window.location.href = "/"
        }
      } 
      catch (error) {
        console.error("An error occurred during the synchronous request:", error);
        // localStorage.removeItem('token')
        // localStorage.removeItem('token_last_checked_at')
        // localStorage.removeItem('user')
        // window.location.href = "/"
        // return null;
      }
    }

    if (validateResult != undefined) {
      console.log("getToken still valid", validateResult)
    }
    return token
  }

  getAuthenticatedObservable() {
    return this.authenticatedSource.asObservable()
  }

  async getCurrentUser() {
    // const user = await firstValueFrom(this.http.get<any>('/api/users/currentUser'))
    // console.log("getCurrentUser", user)
    // localStorage.setItem('user', JSON.stringify(user))
    // this.authenticatedSource.next(true)
  }
  canDo(permission: string) {
    try {
      var user = JSON.parse(localStorage.getItem('user') ?? 'null')
      if (user.permissions.find((perm: any) => perm?.name === permission))
        return true
      return false
    }
    catch (Error) {
      console.error("canDo error", Error)
      return false
    }
  }
  isAuthenticated(): boolean {
    const token = this.getToken()
    if (token) {
      return true
    }
    return false
  }
}
